export const DISPARITAS_HARGA_URL = 'report/report_dispasitas_harga'
export const DISPARITAS_HARGA_ERROR = 'DISPARITAS_HARGA_ERROR'
export const DISPARITAS_HARGA_LOADING = 'DISPARITAS_HARGA_LOADING'
export const DISPARITAS_HARGA_SUCCESS = 'DISPARITAS_HARGA_SUCCESS'